(function() {
  'use strict';

  // 展开单个 item 的辅助函数
  function expandItem(item, section, items, skipAnimation) {
    const header = item.querySelector('.mt-faq-image__item-header');
    const content = item.querySelector('.mt-faq-image__item-content');
    
    if (!header || !content) return;
    
    // 检测是否是移动端
    const isMobile = window.innerWidth <= 749;
    
    const itemsContainer = section.querySelector('.mt-faq-image__items');
    const title = section.querySelector('.mt-faq-image__title');
    
    // 重置所有item的位置和状态
    items.forEach(function(otherItem) {
      if (otherItem !== item) {
        otherItem.classList.remove('is-open');
        const otherHeader = otherItem.querySelector('.mt-faq-image__item-header');
        const otherContent = otherItem.querySelector('.mt-faq-image__item-content');
        if (otherHeader) {
          otherHeader.setAttribute('aria-expanded', 'false');
        }
        if (otherContent) {
          otherContent.setAttribute('aria-hidden', 'true');
          otherContent.style.maxHeight = '0';
        }
        otherItem.style.transform = 'translateY(0)';
        otherItem.style.marginBottom = '0';
      }
    });
    
    // 先计算内容高度（临时展开以获取高度）
    const originalMaxHeight = content.style.maxHeight;
    const originalOpacity = content.style.opacity;
    const originalTransform = item.style.transform;
    
    content.style.maxHeight = 'none';
    content.style.opacity = '1';
    content.style.visibility = 'hidden';
    content.style.position = 'absolute';
    
    const contentHeight = content.scrollHeight;
    
    // 恢复原始样式
    content.style.maxHeight = originalMaxHeight || '';
    content.style.opacity = originalOpacity || '';
    content.style.visibility = '';
    content.style.position = '';
    
    // PC端：向上移动；移动端：正常下拉
    if (isMobile) {
      // 移动端：正常下拉，不移动
      item.style.transform = 'translateY(0)';
      item.style.marginBottom = '0';
      
      // 标题不移动
      if (title) {
        title.style.transform = 'translateY(0)';
      }
      
      // 上面的item也不移动
      let previousSibling = item.previousElementSibling;
      while (previousSibling) {
        if (previousSibling.classList.contains('mt-faq-image__item')) {
          previousSibling.style.transform = 'translateY(0)';
        }
        previousSibling = previousSibling.previousElementSibling;
      }
    } else {
      // PC端：向上移动
      item.style.transform = 'translateY(-' + contentHeight + 'px)';
      // 使用负的 margin-bottom 来消除向上移动后留下的空白
      item.style.marginBottom = '-' + contentHeight + 'px';
      
      // 标题也向上移动相同的距离
      if (title) {
        title.style.transform = 'translateY(-' + contentHeight + 'px)';
      }
      
      // 找到当前item上面的所有item，让它们也向上移动
      let previousSibling = item.previousElementSibling;
      while (previousSibling) {
        if (previousSibling.classList.contains('mt-faq-image__item')) {
          previousSibling.style.transform = 'translateY(-' + contentHeight + 'px)';
        }
        previousSibling = previousSibling.previousElementSibling;
      }
    }
    
    // items容器不需要移动，因为使用 margin-bottom 已经消除了空白
    if (itemsContainer) {
      itemsContainer.style.marginTop = '0';
    }
    
    // 添加类，让 CSS transition 生效
    item.classList.add('is-open');
    header.setAttribute('aria-expanded', 'true');
    content.setAttribute('aria-hidden', 'false');
    
    // 设置最终的 max-height（使用实际内容高度，不限制）
    if (skipAnimation) {
      // 初始化时直接设置高度，不使用动画
      content.style.maxHeight = contentHeight + 'px';
    } else {
      requestAnimationFrame(function() {
        // 移除 max-height 限制，让内容全部显示
        content.style.maxHeight = contentHeight + 'px';
      });
    }
  }

  function initFaqImage() {
    const sections = document.querySelectorAll('[data-mt-faq-image]');
    
    sections.forEach(function(section) {
      const items = section.querySelectorAll('.mt-faq-image__item');
      
      items.forEach(function(item) {
        const header = item.querySelector('.mt-faq-image__item-header');
        const content = item.querySelector('.mt-faq-image__item-content');
        
        if (!header || !content) return;
        
        header.addEventListener('click', function() {
          const isCurrentlyOpen = item.classList.contains('is-open');
          
          // 检测是否是移动端
          const isMobile = window.innerWidth <= 749;
          
          const itemsContainer = section.querySelector('.mt-faq-image__items');
          const title = section.querySelector('.mt-faq-image__title');
          
          // 重置所有item的位置和状态
          items.forEach(function(otherItem) {
            if (otherItem !== item) {
              otherItem.classList.remove('is-open');
              const otherHeader = otherItem.querySelector('.mt-faq-image__item-header');
              const otherContent = otherItem.querySelector('.mt-faq-image__item-content');
              if (otherHeader) {
                otherHeader.setAttribute('aria-expanded', 'false');
              }
              if (otherContent) {
                otherContent.setAttribute('aria-hidden', 'true');
                otherContent.style.maxHeight = '0';
              }
              otherItem.style.transform = 'translateY(0)';
              otherItem.style.marginBottom = '0';
            }
          });
          
          // 切换当前 item
          if (isCurrentlyOpen) {
            item.classList.remove('is-open');
            header.setAttribute('aria-expanded', 'false');
            content.setAttribute('aria-hidden', 'true');
            // 重置所有样式
            content.style.maxHeight = '0';
            item.style.transform = 'translateY(0)';
            item.style.marginBottom = '0';
            // 重置标题位置
            if (title) {
              title.style.transform = 'translateY(0)';
            }
            // 重置items容器的位置
            if (itemsContainer) {
              itemsContainer.style.marginTop = '0';
            }
          } else {
            // 使用展开函数
            expandItem(item, section, items, false);
          }
        });
        
        // 键盘支持
        header.addEventListener('keydown', function(e) {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            header.click();
          }
        });
      });
      
      // 在分辨率大于1920px的情况下，找到第一个可见的 item（不是隐藏的）并默认展开
      if (window.innerWidth > 1919) {
        let firstVisibleItem = null;
        for (let i = 0; i < items.length; i++) {
          const item = items[i];
          // 检查 item 是否可见（不是隐藏的）
          if (!item.classList.contains('mt-faq-image__item--hidden')) {
            firstVisibleItem = item;
            break;
          }
        }
        
        // 如果找到第一个可见的 item，默认展开它
        if (firstVisibleItem) {
          // 使用 setTimeout 确保 DOM 完全加载后再展开
          setTimeout(function() {
            expandItem(firstVisibleItem, section, items, true);
          }, 0);
        }
      }
    });
  }

  // 初始化分页功能
  function initPagination() {
    const sections = document.querySelectorAll('[data-mt-faq-image]');
    
    sections.forEach(function(section) {
      const pagination = section.querySelector('.mt-faq-image__pagination');
      if (!pagination) return;
      
      const dots = pagination.querySelectorAll('.mt-faq-image__dot');
      const items = section.querySelectorAll('.mt-faq-image__item');
      const itemsContainer = section.querySelector('.mt-faq-image__items');
      const title = section.querySelector('.mt-faq-image__title');
      
      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          const targetPage = parseInt(dot.getAttribute('data-page'));
          
          // 更新dot点的active状态
          dots.forEach(function(d) {
            d.classList.remove('mt-faq-image__dot--active');
            d.setAttribute('aria-current', 'false');
          });
          dot.classList.add('mt-faq-image__dot--active');
          dot.setAttribute('aria-current', 'true');
          
          // 关闭所有打开的FAQ项
          items.forEach(function(item) {
            const isOpen = item.classList.contains('is-open');
            if (isOpen) {
              item.classList.remove('is-open');
              const header = item.querySelector('.mt-faq-image__item-header');
              const content = item.querySelector('.mt-faq-image__item-content');
              if (header) {
                header.setAttribute('aria-expanded', 'false');
              }
              if (content) {
                content.setAttribute('aria-hidden', 'true');
                content.style.maxHeight = '0';
              }
              item.style.transform = 'translateY(0)';
              item.style.marginBottom = '0';
            }
          });
          
          // 重置标题位置
          if (title) {
            title.style.transform = 'translateY(0)';
          }
          
          // 显示对应页面的FAQ项，隐藏其他页面的
          items.forEach(function(item) {
            const itemPage = parseInt(item.getAttribute('data-page'));
            if (itemPage === targetPage) {
              item.classList.remove('mt-faq-image__item--hidden');
            } else {
              item.classList.add('mt-faq-image__item--hidden');
            }
          });
          
          // 重置items容器的位置
          if (itemsContainer) {
            itemsContainer.style.marginTop = '0';
          }
        });
      });
    });
  }

  // 初始化
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function() {
      initFaqImage();
      initPagination();
    });
  } else {
    initFaqImage();
    initPagination();
  }
})();

